import { render, staticRenderFns } from "./BriefcaseMedicalIcon.vue?vue&type=template&id=4d0cc3c8"
import script from "./BriefcaseMedicalIcon.vue?vue&type=script&lang=ts"
export * from "./BriefcaseMedicalIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports